import { ValidationResult } from './validation-result.model';
import { LadderState } from '../models/app-state.model';
import { Card } from '../models/card.model';

export function validateLadderState(ladder: LadderState): ValidationResult {
  const errors: string[] = [];

  const positiveLevels = ladder.levels.every(l => Number.isInteger(l) && l > 0);
  if (!positiveLevels) {
    errors.push('Ladder levels must be positive integers.');
  }

  const uniqueLevels = new Set(ladder.levels).size === ladder.levels.length;
  if (!uniqueLevels) {
    errors.push('Ladder level values must be unique.');
  }

  const sortedAscending = ladder.levels.every((val, i, arr) => !i || (val > arr[i - 1]));
  if (!sortedAscending) {
    errors.push('Ladder levels must be sorted ascending.');
  }

  return { isValid: errors.length === 0, errors };
}

export function validateLadderLaneUniqueness(cardsInLane: Card[]): ValidationResult {
  const errors: string[] = [];
  const importanceValues: number[] = [];
  cardsInLane.forEach(c => {
    if (c.showInLadder && c.importance !== null) {
      if (typeof c.importance !== 'number' || !Number.isInteger(c.importance)) {
        errors.push('Card importance must be an integer.');
      } else {
        importanceValues.push(c.importance);
      }
    }
  });

  const uniquePositions = new Set(importanceValues).size === importanceValues.length;
  if (!uniquePositions) {
    errors.push('No two visible cards in the same level may have the same importance.');
  }

  const sortedImportance = [...importanceValues].sort((a, b) => a - b);
  const isContiguous = sortedImportance.every((val, index) => val === index + 1);
  if (!isContiguous && importanceValues.length > 0) {
    errors.push('Cards in a lane must be renumbered contiguously starting from 1.');
  }

  return { isValid: errors.length === 0, errors };
}
